import { render } from "./OperationAuditLogs.vue?vue&type=template&id=8796d648&scoped=true"
import script from "./OperationAuditLogs.vue?vue&type=script&lang=js"
export * from "./OperationAuditLogs.vue?vue&type=script&lang=js"

import "./OperationAuditLogs.vue?vue&type=style&index=0&id=8796d648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8796d648"]])

export default __exports__